<script setup lang="ts">
import type { ShipexkursIconName } from '~/utils/shipexkurs-icons';
import { SHIPEXKURS_ICONS } from '~/utils/shipexkurs-icons';

const props = defineProps<{
  name: ShipexkursIconName;
  label?: string;
}>();

const icon = computed(() => SHIPEXKURS_ICONS[props.name]);
</script>

<template>
  <svg
    :viewBox="icon.viewBox"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :aria-hidden="label ? undefined : 'true'"
    :aria-label="label"
    :role="label ? 'img' : undefined"
    focusable="false"
  >
    <path v-for="path in icon.paths" :key="path" :d="path" />
    <circle
      v-for="circle in icon.circles"
      :key="`${circle.cx}-${circle.cy}-${circle.r}`"
      :cx="circle.cx"
      :cy="circle.cy"
      :r="circle.r"
    />
  </svg>
</template>
